// Durable (localStorage-backed) storage for a survey that was completed
// while the user was logged out. It has to survive a full page reload
// because the sign-up flow requires the user to leave the app, open the
// confirmation email, and click a link before we can resume it.
//
// `profileId`/`topicId` reuse the existing plain string keys that the rest
// of the app (report page, PDF download) already relies on staying in
// localStorage after redirect, so only the answers payload gets its own key
// and is the single source of truth for "is there a pending survey".
const PENDING_SURVEY_ANSWERS_KEY = "pendingSurveyAnswers";
const PROFILE_ID_KEY = "profileId";
const TOPIC_ID_KEY = "topicId";

export const savePendingSurvey = (profileId, topicId, answers) => {
  localStorage.setItem(PROFILE_ID_KEY, profileId);
  localStorage.setItem(TOPIC_ID_KEY, String(topicId));
  localStorage.setItem(PENDING_SURVEY_ANSWERS_KEY, JSON.stringify(answers));
};

export const getPendingSurvey = () => {
  const profileId = localStorage.getItem(PROFILE_ID_KEY);
  const topicId = localStorage.getItem(TOPIC_ID_KEY);
  const rawAnswers = localStorage.getItem(PENDING_SURVEY_ANSWERS_KEY);

  if (!profileId || !topicId || !rawAnswers) return null;

  try {
    const answers = JSON.parse(rawAnswers);
    if (!Array.isArray(answers) || answers.length === 0) return null;
    return { profileId, topicId, answers };
  } catch (e) {
    return null;
  }
};

// Only clears the answers payload (the actual "pending" signal). profileId/
// topicId are intentionally left in place since the report page and PDF
// download flow still need them after the redirect.
export const clearPendingSurvey = () => {
  localStorage.removeItem(PENDING_SURVEY_ANSWERS_KEY);
};
